import {
    ADD_INVOICE,
    UPDATE_INVOICE,
    BASE_URL,
    NOTIFY_PARENTS_NOTIFICATIONS,
    STUDENT_BALANCE,
    STUDENT,
    ADD_BALANCE_CSV,
} from "../util/constants";
import { sendRequest } from "./base";
import axios from "axios";

export const filterByDate = async (fromDate, toDate, token) => {
    const Authorization = `Bearer ${token}`;
    try {
        return sendRequest(
            null,
            "GET",
            `${STUDENT}/balance_date?fromDate=${fromDate}&toDate=${toDate}`,
            {
                Authorization,
            }
        );
    } catch (err) {
        return err;
    }
};

export const filterByGrade = async (grade, token) => {
    const Authorization = `Bearer ${token}`;
    try {
        return sendRequest(null, "GET", `${STUDENT}/all?grade=${grade}`, {
            Authorization,
        });
    } catch (err) {
        return err;
    }
};

export const addInvoice = async (data, token) => {
    const Authorization = `Bearer ${token}`;
    try {
        return sendRequest(data, "POST", ADD_INVOICE, { Authorization });
    } catch (err) {
        return err;
    }
};

export const addBalance = async (data, token) => {

    const Authorization = `Bearer ${token}`;

    try {
        return sendRequest(data, "POST", STUDENT_BALANCE, { Authorization });
    } catch (err) {
        return err;
    }
};

export const updateInvoice = async (invoiceId, data, token) => {
    const Authorization = `Bearer ${token}`;
    try {
        return sendRequest(
            data,
            "PUT",
            `${UPDATE_INVOICE}?invoiceId=${invoiceId}`, { Authorization }
        );
    } catch (err) {
        return err;
    }
};

export const addMultipleInvoices = async (file, token, schoolId, selectedRadio) => {
    const Authorization = `Bearer ${token}`;
    var formData = new FormData();

    formData.append("file", file);
    formData.append("bulkOpt", selectedRadio);
    const options = {
        method: "POST",
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization,
        },
        data: formData,
        url: `${BASE_URL}/${ADD_BALANCE_CSV}?schoolId=${schoolId}`,
    };
    try {
        const { data } = await axios(options);
        if (data) return data;

        throw new Error("Something went wrong please try again");
    } catch (err) {
        throw new Error(err);
    }
};
export const notifyParentsNotifications = async (
    data,
    sms,
    email,
    pushNotification,
    watsapp,
    token
) => {
    const Authorization = `Bearer ${token}`;

    try {
        return await sendRequest(
            data,
            "POST",
            `${NOTIFY_PARENTS_NOTIFICATIONS}?sms=${sms}&email=${email}&pushNotification=${pushNotification}&watsapp=${watsapp}`, {Authorization}
        );
    } catch (error) {
        return error;
    }
};